var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.75C0.75 13.4022 1.80357 15.9457 3.67893 17.8211C5.5543 19.6964 8.09784 20.75 10.75 20.75C13.4022 20.75 15.9457 19.6964 17.8211 17.8211C19.6964 15.9457 20.75 13.4022 20.75 10.75C20.75 8.09784 19.6964 5.5543 17.8211 3.67893C15.9457 1.80357 13.4022 0.75 10.75 0.75C8.09784 0.75 5.5543 1.80357 3.67893 3.67893C1.80357 5.5543 0.75 8.09784 0.75 10.75Z",
    stroke: "#2C6199",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46484 10.75C6.46484 8.09784 6.91637 5.5543 7.7201 3.67893C8.52383 1.80357 9.61392 0.75 10.7506 0.75C11.8872 0.75 12.9773 1.80357 13.781 3.67893C14.5847 5.5543 15.0363 8.09784 15.0363 10.75C15.0363 13.4022 14.5847 15.9457 13.781 17.8211C12.9773 19.6964 11.8872 20.75 10.7506 20.75C9.61392 20.75 8.52383 19.6964 7.7201 17.8211C6.91637 15.9457 6.46484 13.4022 6.46484 10.75Z",
    stroke: "#2C6199",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46484 14.0837H20.0363M1.46484 7.41699H20.0363",
    stroke: "#2C6199",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.fc6b5f62d3459bba99976eb63e4e7506.svg";
export { ForwardRef as ReactComponent };